module.exports = __webpack_public_path__ + "static/media/meetup-bg.f8fb503e.png";